import * as Yup from 'yup';

export const validationSchemaLogin = new Yup.ObjectSchema({
    email:Yup.string().required('Cannot be empty').email('Invalid email'),
    password: Yup.string().required('Cannot be empty')
});

export const initialValuesLogin = {
    email:'',
    password:'',
}

export const feildsLogin = [
    {
        name:'email',
        placeholder:'Enter your email here',
        id:'email',
        type:'email',
        label:'Email'
    },
    {
        name:'password',
        placeholder:'Enter your password here',
        id:'password',
        type:'password',
        label:'Password'
    },
];